"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var parcelsApi = _interopRequireWildcard(require("self-service-api/core/api/parcelsApi"));

var _parcelsAdapter = _interopRequireDefault(require("self-service-api/adapters/parcelsAdapter"));

var getParcels = function getParcels() {
  return parcelsApi.fetchParcels().then(_parcelsAdapter.default);
};

var _default = getParcels;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/api/getParcels.js
// module id = 726
// module chunks = 5 6